export default __webpack_public_path__ + "static/media/080_finish_bad.vp9.c179a252.webm";